import PropTypes from "prop-types";

const RewardAllocationOutcomeSummary = ({ outcome }) => {
  const config = outcome?.outcomeData?.reward_allocation_config || {};

  const formatStrategyName = (strategy) => {
    if (strategy === "PROBABILITY_BASED") return "Probability Based";
    if (strategy === "ORDER_BASED") return "Order Based";
    return strategy || "Not set";
  };

  const rewardsList =
    config.rewards && config.rewards.length > 0
      ? config.rewards.map((r) => r.reward_name).join(", ")
      : "No rewards selected";

  return (
    <>
      <div className="display-flex justify-content-space-between align-items-center w-100 font-bold pb-2">
        Reward Allocation
      </div>
      <hr style={{ marginBottom: "10px" }} color="#DFDFDF" />
      <div style={{ width: "100%" }}>
        <div className="additional-fields-container">
          <div className="field-pair">
            <span className="field-label">Distribution Strategy:</span>
          </div>
          <div className="field-pair-two-column">
            <span className="field-value">
              {formatStrategyName(config.distribution_strategy)}
            </span>
          </div>
        </div>

        <div className="additional-fields-container">
          <div className="field-pair">
            <span className="field-label">Fallback Logic:</span>
          </div>
          <div className="field-pair-two-column">
            <span className="field-value">
              {config.rollover_enabled ? "Active" : "Inactive"}
            </span>
          </div>
        </div>

        <div className="additional-fields-container">
          <div className="field-pair">
            <span className="field-label">Selected Rewards:</span>
          </div>
          <div className="field-pair-two-column">
            <span className="field-value">{rewardsList}</span>
          </div>
        </div>
      </div>
    </>
  );
};

RewardAllocationOutcomeSummary.propTypes = {
  outcome: PropTypes.object.isRequired,
};

export default RewardAllocationOutcomeSummary;
